module.exports = __webpack_public_path__ + "static/media/side2.9905b6d1.jpeg";